export default __webpack_public_path__ + "static/media/Buygenix_logo.ea4be4d3.png";